module.exports = __webpack_public_path__ + "static/a10-b4a68991c5d1c6582bf840c8c38b53d3.jpg";